module.exports = __webpack_public_path__ + "static/img/68.3a475cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/68.jpg
// module id = 15IG
// module chunks = 0